const DEBUG_CONFIG = {
  fpsMeter: false,
  rendererStats: false,
  orbitControls: false,
  axesHelper: false,
  startFromGameplay: false,
  invulnerability: false,
  showControlPanel: false,
};

export default DEBUG_CONFIG;
